// Canonical Firestore field values for locations.type
export const FACILITY_TYPE = {
  EMERGENCY_DEPARTMENT: "Emergency Department",
  CLINIC: "Clinic",
};

// Canonical values for the locations.facilitySubtypes array field.
// A location may have multiple subtypes simultaneously.
// Phase 1 values only — extend this list in future phases as needed.
export const FACILITY_SUBTYPE = {
  CLINIC: "clinic",
  URGENT_CARE: "urgent_care",
};

// All valid subtype values. Used for allowlist validation.
export const ALL_FACILITY_SUBTYPES = Object.values(FACILITY_SUBTYPE);
